import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private excludedUrls = ['/api/status', '/api/captcha/verify']; // Exclude status endpoint and hCaptcha verification endpoint

  constructor(private msalService: MsalService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if request URL is in the excluded list
    if (this.excludedUrls.some(url => req.url.includes(url))) {
      return next.handle(req); // Skip adding Authorization header
    }

    return from(this.msalService.instance.acquireTokenSilent({
      scopes: [environment.azure.scope]
    })).pipe(
      switchMap(tokenResponse => {
        const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokenResponse.accessToken}`
          }
        });
        return next.handle(cloned);
      })
    );
  }
}
